// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3RWTz","title":"Images90_title__3eEUd","images":"Images90_images__2T4-N"};